import { useState } from 'react'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { useVisualStyles } from 'hooks/queries/visualStyles'
import { VisualStyle } from 'types'
import { VisualStyleCard, VisualStyleCardSkeleton } from 'components/VisualStyleCard'
import Styles from './VisualStylesModal.module.scss'

export interface VisualStylesModalProps {
  selectedStyleId: number | null
  onConfirm: (styleId: number | null) => void
  showNoVisualStyleOption?: boolean
}

export const VisualStylesModal = ({
  selectedStyleId: initialSelectedId,
  onConfirm,
  showNoVisualStyleOption = false,
}: VisualStylesModalProps) => {
  const { closeModal } = useModals()
  const { data: visualStyles, isLoading } = useVisualStyles()
  const [selectedStyleId, setSelectedStyleId] = useState<number | null>(initialSelectedId)

  const handleConfirm = () => {
    if (!showNoVisualStyleOption && selectedStyleId === null) return

    onConfirm(selectedStyleId)
    closeModal()
  }

  return (
    <Modal.Root size="lg" onPressOutside={closeModal}>
      <Modal.Header title="Photo Styles" />
      <Modal.Content className={Styles.content}>
        <div className={Styles.grid}>
          {isLoading && [1, 2, 3, 4, 5, 6, 7, 8].map((i) => <VisualStyleCardSkeleton key={i} />)}
          {!isLoading && (
            <>
              {showNoVisualStyleOption ? (
                <VisualStyleCard
                  key={'no-visual-style'}
                  style={null}
                  isSelected={selectedStyleId === null}
                  onSelect={() => setSelectedStyleId(null)}
                />
              ) : null}
              {visualStyles?.map((style: VisualStyle) => (
                <VisualStyleCard
                  key={style.id}
                  style={style}
                  isSelected={selectedStyleId === style.id}
                  onSelect={() => setSelectedStyleId(style.id)}
                />
              ))}
            </>
          )}
        </div>
      </Modal.Content>
      <Modal.Footer sticky className={Styles.footer}>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={closeModal}>
            Cancel
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size="lg" onPress={handleConfirm} isDisabled={!showNoVisualStyleOption && selectedStyleId === null}>
            Confirm Selection
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
